import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, DecimalPipe, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../material.module';
import {ApplicationInterceptor} from './services/Interceptor';
import {FullTableModule} from '@overflo-srl/full-table';
import {environment} from '../../environments/environment';
import {StateService} from './services/state.service';
import {BoardAuthService} from './services/board-auth/board-auth.service';
import {ActorService} from '../actor/services/actor/actor.service';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {ActorEmployeeService} from './services/actor-employee/actor-employee.service';
import {ConstructionTableComponent} from './components/construction-table/construction-table.component';
import {ConstructionService} from '../construction/services/construction/construction.service';
import {SafePipe} from './pipes/safe/safe.pipe';
import {SafeHtmlPipe} from './pipes/safe-html/safe-html.pipe';
import {NotificationDetailsComponent} from './components/notification-details/notification-details.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {BtnCloseDialogComponent} from './components/btn-close-dialog/btn-close-dialog.component';
import {ActorTypePipe} from './pipes/actor-type/actor-type.pipe';
import { ActorRoleDisplayPipe } from './pipes/actor-role-display/actor-role-display.pipe';
import {AlertMessagesBoxComponent} from './components/alert-messages-box/alert-messages-box.component';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {ShowTagListComponent} from './tags/show-tag-list/show-tag-list.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {HasRolePipe} from './pipes/has-role/has-role.pipe';
import {PwaInstallationDialogComponent} from './components/pwa-installation-dialog/pwa-installation-dialog.component';
import {PwaUpdateDialogComponent} from './components/pwa-update-dialog/pwa-update-dialog.component';
import {FooterComponent} from './components/footer/footer.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {PageScrollLinkDirective} from './directives/page-scroll-link/page-scroll-link.directive';
import {NgxFileDropModule} from 'ngx-file-drop';
import {SortByPipe} from './pipes/sort-by/sort-by.pipe';
import {ChooseChipComponent} from "./components/choose-chip/choose-chip.component";
import {
  NotificationPermissionDialogComponent
} from './components/notification-permission-dialog/notification-permission-dialog.component';
import {SearchComponent} from './components/search/search.component';
import {ChooseChipObjectComponent} from './components/choose-chip-object/choose-chip-object.component';
import {PhotosFormComponent} from "./components/dynamic-form/photo/photos-form.component";
import {LoadPhotoBtnComponent} from "./components/dynamic-form/photo/load-photo-btn.component";
import {LoadedPhotosComponent} from "./components/dynamic-form/photo/loaded-photos.component";
import {DynamicFormComponent} from "./components/dynamic-form/dynamic-form.component";
import {BaseFormComponent} from "./components/dynamic-form/base-form.component";
import {SearchPipe} from "./pipes/shared.pipe";
import {MatTableResponsiveDirective} from "./directives/mat-table-responsive/mat-table-responsive.directive";
import {SimpleActorSoaList} from "./components/simple-actor-soa-list/simple-actor-soa-list.component";
import {ShareEntityListComponent} from "./components/share-entity-list/share-entity-list.component";
import {ChooseTagsComponent} from "./tags/choose-tags/choose-tags.component";
import {CustomTagDialogComponent} from "./tags/custom-tag-dialog/custom-tag-dialog.component";
import {CreateCustomTagComponent} from "./tags/create-custom-tag/create-custom-tag.component";
import {IconPipePipe} from './pipes/icon-pipe/icon-pipe.pipe';
import {ColorPickerComponent} from "./components/color-picker/color-picker.component";
import {IconPickerComponent} from "./components/icon-picker/icon-picker.component";
import {ChatTagComponent} from "./tags/chat-tag/chat-tag.component";
import {DialogClosingComponent} from "./components/dialog-closing/dialog-closing.component";
import {DisabledFieldComponent} from "./components/disabled-field/disabled-field.component";
import {
  AlertMessagesBoxDialogComponent
} from "./components/alert-messages-box-dialog/alert-messages-box-dialog.component";
import {
  DateFilterExportDialogComponent
} from "./components/date-filter-export-dialog/date-filter-export-dialog.component";
import {
  ConstructionCucListViewComponent
} from './components/construction-cuc-list-view/construction-cuc-list-view.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ChipInputComponent} from "./components/chip-input/chip-input.component";
import {FilterDialogComponent} from "./components/filter-dialog/filter-dialog.component";
import {FilterDialogElementComponent} from "./components/filter-dialog-element/filter-dialog-element.component";
import {FilterDialogService} from "./services/filter-dailog/filter-dialog.service";
import {FirebaseNotificationService} from "./services/firebase-notification/firebase-notification.service";
import {LightsComponent} from "./components/lights/lights.component";
import {MobileStoreDialogComponent} from "./components/mobile-store-dialog/mobile-store-dialog.component";
import {RouterLinkListComponent} from "./components/router-link-list/router-link-list.component";
import {InfoDialogComponent} from "./components/info-dialog/info-dialog.component";
import {MatChipsModule} from '@angular/material/chips';
import {CheckSwiperWrapperComponent} from './components/check-swiper-wrapper/check-swiper-wrapper.component';
import {CheckSwiperActiveIndexPipe} from './pipes/check-swiper-active-index/check-swiper-active-index.pipe';
import {
  LoadingSnackbarContentComponent
} from "./components/loading-snackbar-content/loading-snackbar-content.component";
import {AddSelectedOptionPipe} from "./pipes/add-selected-option/add-selected-option.pipe";
import {PdfDownloadBtnComponent} from "./components/pdf-download-btn/pdf-download-btn.component";
import {
  AndroidTakePhotoOrGalleryComponent
} from "./components/android-take-photo-or-gallery/android-take-photo-or-gallery.component";
import {ScanComponent} from "./components/scan/scan.component";
import {GeolocateComponent} from "./components/geolocate/geolocate.component";
import {SetHiddenSelectOptionsPipe} from './pipes/set-hidden-select-options/set-hidden-select-options.pipe';
import {
  GetMultiselectDisplayedValuePipe
} from './pipes/get-multiselect-displayed-value/get-multiselect-displayed-value.pipe';
import {MultiSelectWithSearchComponent} from "./components/multi-select-with-search/multi-select-with-search.component";
import {GetVisibleSelectOptionsPipe} from './pipes/get-visible-select-options/get-visible-select-options.pipe';
import {IsBaseUserOrHasRolePipe} from './pipes/is-base-user-or-has-role/is-base-user-or-has-role.pipe';
import {DistanceFormatPipe} from './pipes/distance-format/distance-format.pipe';
import {DateInputComponent} from "./components/date-input/date-input.component";
import {
  SearchWithAutocompleteComponent
} from "./components/search-with-autocomplete/search-with-autocomplete.component";
import {FilterArrayBySearchValuePipe} from "./pipes/filter-array-by-search-value/filter-array-by-search-value.pipe";
import {OfflineMessagesComponent} from "./components/offline-messages/offline-messages.component";
import {AvatarComponent} from "./components/avatar/avatar.component";
import {PartialStringPipe} from "./pipes/partial-string/partial-string.pipe";
import {AvatarColorPipe} from "./pipes/avatar-color/avatar-color.pipe";
import {ChatDatePipe} from "./pipes/chat-date/chat-date.pipe";
import {NotificationSnackbarComponent} from "./components/notification-snackbar/notification-snackbar.component";
import {RouteListenerService} from "./services/route-listener/route-listener.service";
import {MatDatepickerAdapter} from "./adapters/mat-datepicker-adapter.adapter";
import {PdfLoadingComponent} from "./components/pdf-loading/pdf-loading.component";
import {MultiSelectDialogComponent} from "./components/multi-select-dialog/multi-select-dialog.component";
import { GetDocumentLabelPipe } from './pipes/get-document-label/get-document-label.pipe';
import { BadgeComponent } from './components/badge/badge.component';
import {DialogExpandBtnComponent} from "./components/dialog-expand-btn/dialog-expand-btn.component";
import {ApplyFnOnElementPipe} from "./pipes/apply-fn-on-element.pipe";
import {IsInListPipe} from './pipes/is-in-list/is-in-list.pipe';
import {IsHighHeatRiskPipe} from './pipes/heat-risk/is-high-heat-risk.pipe';

@NgModule({ declarations: [
        PageNotFoundComponent,
        ConstructionTableComponent,
        SafePipe,
        SafeHtmlPipe,
        ActorTypePipe,
        ActorRoleDisplayPipe,
        NotificationDetailsComponent,
        BtnCloseDialogComponent,
        AlertMessagesBoxComponent,
        ConfirmationDialogComponent,
        PwaInstallationDialogComponent,
        PwaUpdateDialogComponent,
        ShowTagListComponent,
        HasRolePipe,
        FooterComponent,
        SimpleActorSoaList,
        PageScrollLinkDirective,
        SortByPipe,
        ChooseChipComponent,
        SearchComponent,
        ChooseChipObjectComponent,
        PhotosFormComponent,
        LoadPhotoBtnComponent,
        LoadedPhotosComponent,
        DynamicFormComponent,
        BaseFormComponent,
        SearchPipe,
        MatTableResponsiveDirective,
        NotificationPermissionDialogComponent,
        ShareEntityListComponent,
        ChooseTagsComponent,
        CustomTagDialogComponent,
        CreateCustomTagComponent,
        IconPipePipe,
        ColorPickerComponent,
        IconPickerComponent,
        ChatTagComponent,
        DialogClosingComponent,
        DisabledFieldComponent,
        DateFilterExportDialogComponent,
        AlertMessagesBoxDialogComponent,
        ChipInputComponent,
        FilterDialogComponent,
        FilterDialogElementComponent,
        ConstructionCucListViewComponent,
        LightsComponent,
        MobileStoreDialogComponent,
        InfoDialogComponent,
        RouterLinkListComponent,
        CheckSwiperWrapperComponent,
        CheckSwiperActiveIndexPipe,
        LoadingSnackbarContentComponent,
        AddSelectedOptionPipe,
        PdfDownloadBtnComponent,
        AndroidTakePhotoOrGalleryComponent,
        ScanComponent,
        GeolocateComponent,
        SetHiddenSelectOptionsPipe,
        GetMultiselectDisplayedValuePipe,
        MultiSelectWithSearchComponent,
        GetVisibleSelectOptionsPipe,
        DistanceFormatPipe,
        IsBaseUserOrHasRolePipe,
        DateInputComponent,
        SearchWithAutocompleteComponent,
        FilterArrayBySearchValuePipe,
        OfflineMessagesComponent,
        AvatarComponent,
        PartialStringPipe,
        AvatarColorPipe,
        ChatDatePipe,
        NotificationSnackbarComponent,
        PdfLoadingComponent,
        MultiSelectDialogComponent,
        GetDocumentLabelPipe,
        BadgeComponent,
        DialogExpandBtnComponent,
        ApplyFnOnElementPipe,
        IsInListPipe,
        IsHighHeatRiskPipe
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        PageNotFoundComponent,
        ConstructionTableComponent,
        RouterModule,
        FullTableModule,
        SafePipe,
        SafeHtmlPipe,
        ActorTypePipe,
        ActorRoleDisplayPipe,
        NotificationDetailsComponent,
        MatDatepickerModule,
        MatMomentDateModule,
        BtnCloseDialogComponent,
        AlertMessagesBoxComponent,
        ShowTagListComponent,
        HasRolePipe,
        FontAwesomeModule,
        InfiniteScrollModule,
        NgxFileDropModule,
        FooterComponent,
        SimpleActorSoaList,
        PageScrollLinkDirective,
        SortByPipe,
        ChooseChipComponent,
        SearchComponent,
        ChooseChipObjectComponent,
        SearchPipe,
        LoadPhotoBtnComponent,
        DynamicFormComponent,
        MatTableResponsiveDirective,
        ShareEntityListComponent,
        ChooseTagsComponent,
        CustomTagDialogComponent,
        IconPipePipe,
        ColorPickerComponent,
        IconPickerComponent,
        ChatTagComponent,
        DialogClosingComponent,
        DisabledFieldComponent,
        ChipInputComponent,
        FilterDialogComponent,
        CreateCustomTagComponent,
        ConstructionCucListViewComponent,
        LightsComponent,
        MobileStoreDialogComponent,
        InfoDialogComponent,
        RouterLinkListComponent,
        CheckSwiperWrapperComponent,
        LoadingSnackbarContentComponent,
        FormsModule,
        AddSelectedOptionPipe,
        PdfDownloadBtnComponent,
        AndroidTakePhotoOrGalleryComponent,
        ScanComponent,
        GeolocateComponent,
        SetHiddenSelectOptionsPipe,
        GetMultiselectDisplayedValuePipe,
        MultiSelectWithSearchComponent,
        DistanceFormatPipe,
        IsBaseUserOrHasRolePipe,
        DateInputComponent,
        SearchWithAutocompleteComponent,
        FilterArrayBySearchValuePipe,
        OfflineMessagesComponent,
        AvatarComponent,
        PartialStringPipe,
        AvatarColorPipe,
        ChatDatePipe,
        PdfLoadingComponent,
        MultiSelectDialogComponent,
        GetDocumentLabelPipe,
        NgOptimizedImage,
        BadgeComponent,
        DialogExpandBtnComponent,
        ApplyFnOnElementPipe,
        IsInListPipe,
        IsHighHeatRiskPipe
    ], imports: [CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        RouterModule,
        FullTableModule.forRoot(environment.BASE_PATH),
        MatDatepickerModule,
        MatMomentDateModule,
        FontAwesomeModule,
        InfiniteScrollModule,
        NgxFileDropModule,
        FormsModule,
        MatProgressBarModule,
        MatChipsModule,
        NgOptimizedImage], providers: [
        HasRolePipe,
        SearchPipe,
        ApplicationInterceptor,
        { provide: HTTP_INTERCEPTORS, useClass: ApplicationInterceptor, multi: true },
        DatePipe,
        StateService,
        BoardAuthService,
        ConstructionService,
        ActorService,
        ActorEmployeeService,
        DecimalPipe,
        FilterDialogService,
        FirebaseNotificationService,
        AddSelectedOptionPipe,
        PartialStringPipe,
        AvatarColorPipe,
        ChatDatePipe,
        RouteListenerService,
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { strict: true } },
        { provide: DateAdapter, useClass: MatDatepickerAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: ['L', 'LL', 'DD/MM/YYYY'],
                },
                display: {
                    dateInput: 'DD/MM/YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class SharedModule {}
